import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpService} from "../http/http.service";
import {
  Category,
  BenefitBoard
} from "./benefit";


@Injectable()
export class BenefitService {
  private url = '/api/heyservice';

  constructor(private httpService: HttpService) {
  }

  getCategories(): Observable<Category[]> {
    return this.httpService.get(`${this.url}/categories`)
      .map(res => res.json() as Category[]);
  }

  gets(category: string, search: string): Observable<BenefitBoard[]> {
    return this.httpService.get(
      `${this.url}/list?`+
      `${category ? `category=${category}&` : ''}`+
      `${search ?   `search=${search}&`     : ''}`
      )
      .map(res => res.json() as BenefitBoard[]);
  }

  get(id: number): Observable<BenefitBoard> {
    return this.httpService.get(`${this.url}/${id}`)
      .map(res => res.json() as BenefitBoard);
  }

  save(board: BenefitBoard): Observable<BenefitBoard> {
    if (board.id) {
      return this.httpService.put(`${this.url}`, board)
        .map(res => res.json() as BenefitBoard);
    } else {
      return this.httpService.post(`${this.url}`, board)
        .map(res => res.json() as BenefitBoard);
    }
  }

  delete(id: number){
    return this.httpService.delete(`${this.url}/${id}`)
      .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/service/benefit/benefit.service.ts